import { Component, OnInit} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';

@Component({
  selector: 'app-trinka-cloud',
  templateUrl: './trinka-cloud.component.html',
  styleUrls: ['./trinka-cloud.component.scss']
})
export class TrinkaCloudComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
    ) { }

  ngOnInit() {
    this.titleService.setTitle('免費線上文法編輯器與文法檢查工具｜Trinka');
    this.metaTagService.updateTag({ name: 'description', content: '立即使用 Trinka 免費線上英文文法與拼寫檢查器。由 AI 驅動的先進文法校對系統，能即時修正您的寫作內容，提升語言品質與專業度。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '文法檢查工具應用程式，上下文拼寫糾正，學術寫作應用程式，技術寫作應用程式，文法糾正工具，自動文法檢查工具，英語寫作工具' });
    this.metaTagService.updateTag({ property: 'og:title', content: '免費線上文法編輯器與文法檢查工具｜Trinka' });
    this.metaTagService.updateTag({ property: 'og:description', content: '立即使用 Trinka 免費線上英文文法與拼寫檢查器。由 AI 驅動的先進文法校對系統，能即時修正您的寫作內容，提升語言品質與專業度。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/trinkacloud' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/trinkacloud' });
  }

}
